var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.couner === 0)?_c('Chat',{attrs:{"person":_vm.person},on:{"next":_vm.next,"sendZodiak":_vm.getZodiak}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }